import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/components/Home.vue';
import AboutPage from '@/components/About.vue';
import PrivacyPage from '@/views/Privacy.vue';
import TermsPage from '@/views/Tos.vue';
import AccountDeletionPage from '@/views/AccountDeletion.vue'; // <-- added import
import SystemList from '@/components/SystemList.vue'; // Import component
import HkZoho from '@/components/HkZoho.vue'; // Import component
import HkRetails from '@/components/HkRetails.vue'; // Import component
import HkDrivers from '@/components/HkDrivers.vue'; // Import component
import HkUser from '@/components/HkUser.vue'; // Import component
import GasPrice from '@/components/GasPrice.vue'; // Import component
import HelloWorld from '@/components/HelloWorld.vue'; // Import component
import TimeLine from '@/components/Timeline.vue'; // Import component
import UserLogin from '@/components/UserLogin.vue'; // Import component
import UserLogout from '@/components/UserLogout.vue'; // Import component
import AttEmp from '@/components/AttEmp.vue';
import AttUser from '@/components/AttUser.vue';
import AttPe from '@/components/AttPerformance.vue';
import LoanCalculator from '@/components/LoanCalculator.vue';
import SavingCalculator from '@/components/SavingCalculator.vue';
import FuelInvestmentCalculator from '@/components/FuelInvestmentCalculator.vue';
import UserProfile from '@/components/UserProfile.vue';
import ApprovalFlow from '@/components/ApprovalFlow.vue';
import { useAuthStore } from '@/stores/authStore';

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
      path: '/approve',
      name: 'ApprovalFlow',
      component: ApprovalFlow
    },
  {
    path: '/hkoil',
    name: 'SystemList',
    component: SystemList, // Sử dụng component đã import
    props: (route) => ({ systems: route.query.systems }),
    beforeEnter: (to, from, next) => {
          const authStore = useAuthStore();
          if (!authStore.isAuthenticated) {
            next('/dang-nhap'); // Redirect về trang login nếu chưa đăng nhập
          } else {
            next(); // Cho phép truy cập nếu đã đăng nhập
        }
    } 
  },
  {
        path: '/hkretails',
        name: 'HkRetails',
        component: HkRetails, // Sử dụng component đã import
      beforeEnter: (to, from, next) => {
    const authStore = useAuthStore();
    if (authStore.isAuthenticated) {
      next(); // Cho phép truy cập nếu đã đăng nhập
    } else {
      next('/dang-nhap'); // Redirect về trang đăng nhập nếu chưa đăng nhập
    }
  },
        props: (route) => ({ systems: route.query.retailSystems }),meta: { noLayout: true,hkRetails: true, hkUser: false }
  },
  {
  path: '/hkdrivers',
  name: 'HkDrivers',
  component: HkDrivers, // Sử dụng component đã import
  beforeEnter: (to, from, next) => {
    const authStore = useAuthStore();
    if (authStore.isAuthenticated) {
      next(); // Cho phép truy cập nếu đã đăng nhập
    } else {
      next('/dang-nhap'); // Redirect về trang đăng nhập nếu chưa đăng nhập
    }
  },
  props: (route) => ({ systems: route.query.driverSystems }),
  meta: { 
    noLayout: true, 
    hkRetails: false, 
    hkUser: false, 
    hkDrivers: true 
  }
},
  {
        path: '/hkzoho',
        name: 'HkZoho',
        component: HkZoho, // Sử dụng component đã import
        props: (route) => ({ systems: route.query.systems }),meta: { noLayout: true, hkUser: false }
  },
  {
        path: '/hkuser',
        name: 'HkUser',
        component: HkUser, // Sử dụng component đã import
        props: (route) => ({ userSystems: route.query.userSystems }),meta: { noLayout: true, hkUser:true }
  },
  { path: '/loan', name: 'LoanCalculator',component: LoanCalculator},
  { path: '/saving', name: 'SavingCalculator',component: SavingCalculator},
  { path: '/payback', name: 'FuelInvestmentCalculator',component: FuelInvestmentCalculator},
  {
    path: '/about',
    name: 'AboutPage',
    component: AboutPage
  },{
    path: '/privacy',
    name: 'PrivacyPage',
    component: PrivacyPage,
    props: (route) => ({ systems: route.query.systems }),meta: { noLayout: true, hkUser: false }
  },{
    path: '/tos',
    name: 'TermsOfServicePage',
    component: TermsPage,props: (route) => ({ systems: route.query.systems }),meta: { noLayout: true, hkUser: false }
  },
  {
    path: '/yeu-cau-xoa-tai-khoan',
    name: 'AccountDeletion',
    component: AccountDeletionPage,
    meta: { noLayout: true } // page độc lập, không cần header chung
  },
  {
    path: '/att-em',
    name: 'AttEmp',
    component: AttEmp
  },
   {
        path: '/att-user',
        name: 'AttUser',
        component: AttUser,
        beforeEnter: (to, from, next) => {
          const authStore = useAuthStore();
          if (!authStore.isAuthenticated) {
            next('/dang-nhap'); // Redirect về trang login nếu chưa đăng nhập
          } else {
            next(); // Cho phép truy cập nếu đã đăng nhập
        }
    },
   },
  {
    path: '/att-pe',
    name: 'AttPe',
    component: AttPe,
    beforeEnter: (to, from, next) => {
          const authStore = useAuthStore();
          if (!authStore.isAuthenticated) {
            next('/dang-nhap'); // Redirect về trang login nếu chưa đăng nhập
          } else {
            next(); // Cho phép truy cập nếu đã đăng nhập
        }
    }  
  },
  {
    path: '/gas-price',
    name: 'GasPrice',
    component: GasPrice
  },
  {
    path: '/timeline',
    name: 'TimeLine',
    component: TimeLine,
    beforeEnter: (to, from, next) => {
          const authStore = useAuthStore();
          if (!authStore.isAuthenticated) {
            next('/dang-nhap'); // Redirect về trang login nếu chưa đăng nhập
          } else {
            next(); // Cho phép truy cập nếu đã đăng nhập
        }
    }
  },
  {
      path: '/dang-nhap',
      name: 'UserLogin',
      component: UserLogin
  },
  {
      path: '/dang-nhap',
      name: 'UserLogin',
      component: UserLogin,
      beforeEnter: (to, from, next) => {
        const authStore = useAuthStore();
        if (authStore.isAuthenticated) {
          next('/'); // Redirect về trang chính nếu đã đăng nhập
        } else {
          next(); // Cho phép truy cập nếu chưa đăng nhập
        }
      },
   },
  {
      path: '/logout',
      name: 'Logout',
      component: UserLogout,
      beforeEnter: (to, from, next) => {
        const authStore = useAuthStore();
        if (!authStore.isAuthenticated) {
          next('/dang-nhap'); // Redirect về trang login nếu chưa đăng nhập
        } else {
          next(); // Cho phép truy cập nếu đã đăng nhập
        }
      },
  },
  {
    path: '/profile',
    name: 'UserProfile',
    component: UserProfile,
    beforeEnter: (to, from, next) => {
      const authStore = useAuthStore();
      if (!authStore.isAuthenticated) {
        next('/dang-nhap'); // Redirect về trang login nếu chưa đăng nhập
      } else {
        next(); // Cho phép truy cập nếu đã đăng nhập
      }
    },
},
{
    path: '/hello-world',
    name: 'HelloWorld',
    component: HelloWorld,
    props: (route) => ({ msg: route.query.msg || 'Welcome to Your Vue.js App' }) // Truyền msg nếu có
}
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
